export const env = {
  mode: import.meta.env.MODE,
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  fleetPilotSchedulingUrl:
    import.meta.env.VITE_FLEET_PILOT_SCHEDULING_URL?.trim() ?? "",
  sentryDsn: import.meta.env.VITE_SENTRY_DSN?.trim() ?? "",
  sentryEnvironment:
    import.meta.env.VITE_SENTRY_ENVIRONMENT?.trim() ?? import.meta.env.MODE,
  sentryRelease: import.meta.env.VITE_SENTRY_RELEASE?.trim() ?? "v2-shell",
}
